import {
  ActiveCoins,
  CoinInfoT,
  Assets,
  LatestPriceResponse,
  Companies,
  Company,
  Markets,
} from "../services/types";

export type InitialState = {
  authState: {
    token: string;
    address: string;
    publicKey: string;
  };
  marketState: {
    ownAssets: Assets["balances"];
    markets: Markets["markets"];
    coinInfo: CoinInfoT;
  };
  settingsState: {
    theme: string;
  };
  walletState: {
    address: string;
    balance: number;
    confirmations: number;
  };
};

export type RootState = {
  authReducer: {
    token: string;
    address: string;
    publicKey: string;
  };
  marketReducer: {
    ownAssets: Assets["balances"];
    markets: Markets["markets"];
    coinInfo: CoinInfoT;
  };
  settingsReducer: {
    theme: string;
  };
  walletReducer: {
    address: string;
    balance: number;
    confirmations: number;
  };
};

// Auth reducer
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const USER_LOGOUT = "USER_LOGOUT";

export type LoginSuccessAction = {
  type: typeof LOGIN_SUCCESS;
  payload: {
    token: string;
    user: { publicaddress: string; publicKey: string };
  };
};

export type LogoutAction = {
  type: typeof USER_LOGOUT;
};

export type AuthAction = LoginSuccessAction | LogoutAction;

// Market reducer
export const ACTIVE_COINS_FETCHED = "ACTIVE_COINS_FETCHED";
export const ASSETS_DATA_FETCHED = "ASSETS_DATA_FETCHED";
export const MARKET_DATA_FETCHED = "MARKET_DATA_FETCHED";
export const LATEST_PRICES_FETCHED = "LATEST_PRICES_FETCHED";
export const LATEST_TOKEN_PRICE_FETCHED = "LATEST_TOKEN_PRICE_FETCHED";
export const COMPANY_DATA_FETCHED = "COMPANY_DATA_FETCHED";
export const COIN_INFO_SELECTED = "COIN_INFO_SELECTED";
export const COIN_INFO_REMOVED = "COIN_INFO_REMOVED";
export interface AssetsDataFetchedAction {
  type: typeof ASSETS_DATA_FETCHED;
  payload: Assets["balances"];
}
export interface ActiveCoinsFetchedActionT {
  type: typeof ACTIVE_COINS_FETCHED;
  payload: ActiveCoins;
}
export interface MarketDataFetchedActionT {
  type: typeof MARKET_DATA_FETCHED;
  payload: Markets["markets"];
}
export interface LatestPriceFetchedActionT {
  type: typeof LATEST_PRICES_FETCHED;
  payload: LatestPriceResponse[];
}
export interface CompanyDataFetchedActionT {
  type: typeof COMPANY_DATA_FETCHED;
  payload: Companies;
}

export type SelectCoinInfo = {
  type: typeof COIN_INFO_SELECTED;
  payload: {
    name: string;
    assetId: string;
    price: number;
    company: Company;
  };
};

export type RemoveCoinInfo = {
  type: typeof COIN_INFO_REMOVED;
};

export type UpdateLatestTokenPrice = {
  type: typeof LATEST_TOKEN_PRICE_FETCHED;
  payload: { price: number };
};

export type MarketActionsT =
  | ActiveCoinsFetchedActionT
  | AssetsDataFetchedAction
  | MarketDataFetchedActionT
  | LatestPriceFetchedActionT
  | CompanyDataFetchedActionT
  | SelectCoinInfo
  | UpdateLatestTokenPrice
  | RemoveCoinInfo;

// Settings reducer
export const THEME_CHANGE = "THEME_CHANGE";
export const TOGGLE_SETTINGS_OPTION = "TOGGLE_SETTINGS_OPTION";

export type ToggleThemeAction = {
  type: typeof THEME_CHANGE;
};

export type ToggleSettingsAction = {
  type: typeof TOGGLE_SETTINGS_OPTION;
  payload: { key: string };
};

export type SettingActions = ToggleSettingsAction | ToggleThemeAction;

// Wallet reducer
export const GET_BALANCE = "GET_BALANCE";

export type GetBalanceAction = {
  type: typeof GET_BALANCE;
  payload: { address: string; balance: number; confirmations: number };
};

export type WalletActions = GetBalanceAction;
